import { ChangeDetectorRef, Component, ElementRef, HostListener, Inject, ViewChild } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InventoryItem } from '@contracts/interfaces/inventory-item.interface';
import { InventoryService } from '../../services/inventory.service';
import { InventoryItemFactory } from '../../factories/inventory-item.factory';
import { InventoryCategory } from '@contracts/interfaces/inventory-category';
import { InventoryCategoryService } from '../../services/inventory-category.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'ap-inventory-item-dialog-dialog',
  templateUrl: 'inventory-item.dialog.html',
  styleUrls: ['./inventory-item.dialog.scss', 'sidebar.scss']
})
export class InventoryItemDialogComponent {
  public loaded = false;
  
  public comment: string = "";
  public item: InventoryItem = null;
  public list: number[];

  public currentIndex: number = null;

  public hasEditted = false;
  public isNew = false;

  public itemTemplate: any;

  public categories: InventoryCategory[] = [];
  public currentCategory: InventoryCategory = null;

  public notFound = false;
  public number = 0;

  public error = false;

  private currentItem = null;

  public tab = "item-data";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public inventoryService: InventoryService,
    private inventoryCategoryService: InventoryCategoryService,
    public dialogRef: MatDialogRef<InventoryItemDialogComponent>,
    private route: ActivatedRoute,
    private router: Router
    ) {}

    @HostListener('document:keydown', ['$event'])
    navigateWithArrowKeys(event: KeyboardEvent) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      if (event.defaultPrevented || event.repeat || event.isComposing ||
          event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      if (!this.loaded || !this.item || !this.list || this.currentIndex == null) return;
      if (this.dialog.openDialogs[this.dialog.openDialogs.length - 1] !== this.dialogRef) return;

      const target = event.target as HTMLElement;
      if (target?.closest('input, textarea, select, [contenteditable]:not([contenteditable="false"]), [role="textbox"], [role="combobox"], [role="slider"], [role="spinbutton"], [role="listbox"], [role="menu"], [role="tablist"]')) return;

      const index = this.currentIndex + (event.key === 'ArrowLeft' ? -1 : 1);
      if (index < 0 || index >= this.list.length) return;

      event.preventDefault();
      if (event.key === 'ArrowLeft') {
        this.previous();
      } else {
        this.next();
      }
    }

    ngOnInit() {
      let itemNumber = null;
      if (this.data.item == null) {
        this.route.params.subscribe(params => {
          this.number = params.itemNumber;
          itemNumber = params.itemNumber;
        });
      } else {
        itemNumber = this.data.item.number;
      }
      
      this.list = this.data.list;
      this.currentIndex = this.data.currentIndex;

      this.load(itemNumber);
    }

    load (number: number) {
      this.loaded = false;
      this.error = false;

      this.inventoryCategoryService.find({}).subscribe((categories: InventoryCategory[]) => {
        this.categories = categories;


        this.inventoryService.get(number).subscribe((item: InventoryItem)=> {
          
          if (item == null) {
            this.notFound = true;
          }
    
          this.item = item;
          this.currentItem = this.item.number;

          for (let category of this.categories) {
            if (category.id == this.item.category) {
              this.currentCategory = category;
            }
          }

          window.history.pushState({}, '',`/inventory/c/${this.item.category}/${this.item.number}`);
          this.loaded = true;
        });
      });
    }

    newItem() {
      this.inventoryService.create(InventoryItemFactory.new(this.item.category)).subscribe((item: InventoryItem) => {
        this.isNew = true;
        this.item = item;
        this.list.splice(this.currentIndex, 0, this.item.number);
        this.currentIndex++;
      });
    }

    duplicateItem() {

      this.inventoryService.get(this.item.number).subscribe((itemToDuplicate: InventoryItem) => {
        let item = InventoryItemFactory.new();
        item.category = itemToDuplicate.category;
        item.features = itemToDuplicate.features;
        item.title = itemToDuplicate.title;
  
        this.inventoryService.create(item).subscribe((item: InventoryItem) => {
          this.item = item;
          this.list.splice(this.currentIndex, 0, this.item.number);
          this.currentIndex++;
        })
      })
    }

    deleteItem() {
      this.inventoryService.deleteOne(this.item).subscribe((r: any) => {
        this.dialogRef.close();
      })
    }

    next() {
      this.item = null;
      
      this.currentIndex++;

      if (this.currentIndex > this.list.length-1) {
        this.dialogRef.close();
        window.history.pushState({}, '',`/inventory/c/${this.item.category}`);
      } else {
        this.load(this.list[this.currentIndex]);
      }
    }

    previous() {
      this.item = null;

      this.currentIndex--;

      if (this.currentIndex < 0) {
        this.dialogRef.close();
        window.history.pushState({}, '',`/inventory/c/${this.item.category}`);
      } else {
          this.load(this.list[this.currentIndex]);
      }
    }

    close() {
      this.inventoryService.get(this.item.number).subscribe((item: InventoryItem) => {
        if (item.status == 'empty') {
          this.inventoryService.deleteOne(item).subscribe(r=> {
            this.dialogRef.close();
          })
        } else {
          this.dialogRef.close();
        }
      });
    }

    
  
    getComponentDefinition(name: string) {
  
      if (this.currentCategory.itemTemplate != undefined) {
        for (let definition of this.currentCategory.itemTemplate) {
          if (definition.component == name) {
            return definition.data;
          }
        }
      }
    }
  
    hasComponentDefinition(name: string) {
  
      if (this.currentCategory.itemTemplate != undefined) {
        for (let definition of this.currentCategory.itemTemplate) {
          if (definition.component == name) {
            return true;
          }
        }
      }
  
      return false;
    }
    
    toggleCheckout() {
      this.inventoryService.toggleCheckout(this.item).subscribe();
    }
  
    getTitle(title: string) {
      if (title.trimStart().length > 0) {
        return title;
      } else {
        return "untitled item";
      }
    }
  
    showExample() {
      this.inventoryService.get(this.currentCategory.guide.exampleItem).subscribe((item: InventoryItem) => {
        this.inventoryService.openInventoryItemDialog(item, null, null, (r) => {});
      })
    }

    changeItemCategory(category: number) {
      this.loaded = false;
      this.item.category = category;
      this.inventoryService.updateOne(this.item).subscribe(r => {
        this.load(this.item.number);
      });

    }
}
